import { CircularProgress, Grid, IconButton, MenuItem, Paper, Typography, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getJoinedGreenUsers, getTicketById, updateTicket } from '../../Redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { isGreenUser } from '../../utils/Common';

export default function TicketDetails() {
    const { facilityId: facility_id, client_id: client_id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { ticket_id } = useParams();
    const [ticketData, setTicketData] = useState({});
    const [showLoader, setShowLoader] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState('');
    const [comments, setComments] = useState('');
    const [greenUsers, setGreenUsers] = useState([])
    const [selectedAssignee, setSelectedAssignee] = useState('');

    // Calculate ticket aging in days
    const calculateTicketAging = (createdAt) => {
        if (!createdAt) return '--';
        const created = new Date(createdAt);
        const now = new Date();
        const diffTime = Math.abs(now - created);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
    };

    const state = useSelector(st => st);
    const { currentUser: { uniqueId } } = state

    const ticketsQueryParams = localStorage.getItem("ticketsQueryParams");
    const digiTicketsQueryParams = localStorage.getItem("digiTicketsQueryParams");
    const clientTicketsQueryParams = localStorage.getItem("clientTicketsQueryParams");

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setShowLoader(true)
        let greenUsersAvailable = null;
            try {
                const greenUsersResponse = await dispatch(getJoinedGreenUsers());
                if (!greenUsersResponse.data.success) {
                    return;
                }
                greenUsersAvailable = greenUsersResponse.data.allData;
                const activeUsers = greenUsersAvailable?.filter(item => item.status != 'Inactive');
                const users = activeUsers?.map(item => item.user_id)
                setGreenUsers(users);
            } catch (error) {
                console.error("Error fetching green users data:", error);
            }
        dispatch(getTicketById(ticket_id)).then((res) => {
            if (res && res.status === 200) {
                setShowLoader(false)
                const respData = res?.data?.ticket
                setSelectedStatus(respData?.status);
                setComments(respData?.ex_data?.comments || "");
                setSelectedAssignee(respData?.assignee)
                if (!respData) {
                    return;
                }
                setTicketData(respData)
            }
        })
    }

    const properties = [
        { label: 'Facility Name:', value: ticketData?.facility?.facility_name || '--' },
        {
            label: 'Assignee:',
            value: (
              <Select
                value={selectedAssignee}
                onChange={(e) => setSelectedAssignee(e.target.value)}
                size="small"
                disabled={!(isGreenUser(uniqueId))}
              >
                {!greenUsers.includes(selectedAssignee) && selectedAssignee && (
                    <MenuItem value={selectedAssignee} disabled>
                    {selectedAssignee}
                    </MenuItem>
                )}
                {greenUsers.map((email) => (
                    <MenuItem key={email} value={email}>
                    {email}
                    </MenuItem>
                ))}
              </Select>
            )
          },
        { label: 'Ticket ID:', value: ticketData?.id || '--' },
        {
            label: 'Status:',
            value: (
              <Select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                size="small"
                disabled={!(isGreenUser(uniqueId))}
              >
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="On Hold">On Hold</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
              </Select>
            )
          },
          {
            
        },
        { label: 'Title:', value: ticketData?.title || '--' },
        { label: 'Description:', value: ticketData?.description || '--' },
        { label: 'Created Person:', value: ticketData?.ex_data?.created_person || '--' },
        { label: 'Created At:', value: new Date(ticketData?.created_at).toLocaleString() || '--' },
        { label: 'Owner Details:', value: ticketData?.ex_data?.details?.owners?.map(item => `${item?.full_name || '--' } : ${item?.email || '--'}`).join(', ')},
    ];
    
    if (ticketData?.scope === 'Internal') {
        properties.push(
            { label: 'Ticket Aging:', value: calculateTicketAging(ticketData?.created_at) },
            { label: 'Last Error Value:', value: ticketData.ex_data.lastErrorValue || '--' },
        );
    }
    if (ticketData?.scope !== 'Internal') {
        properties.push({
            label: '',
            value: ticketData?.ex_url 
                ? <a href={ticketData.ex_url} target="_blank">View ticket details in Zoho</a>
                : '--'
        });
    }
    if(isGreenUser(uniqueId)){
        properties.push({
            label: 'Comments:',
            value: (
              <TextField
                multiline
                minRows={3}
                fullWidth
                size="small"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                disabled={!isGreenUser(uniqueId)}
              />
            )
        })
    }

    let ticketDetails 

    if( showLoader ) {
        ticketDetails = (
            <Paper sx={{ padding: 2 }} >
                <Grid container item className='w3-padding' justifyContent='center'>
                    <CircularProgress />
                </Grid>
            </Paper>
        )
    } else if(ticketData && Object.keys(ticketData).length !== 0) {
        ticketDetails = (
            <Paper 
                sx={{
                    wordWrap: 'break-word',
                    padding: {
                    xs: 0,
                    sm: 2, 
                    md: 2  
                    }
                }}
                >
                {properties.map((property, index) => (
                    <div key={index}>
                        <Grid container item className='w3-padding'>
                            <Grid item xs={12} sm={6} md={6}>
                                <Typography sx={{ fontWeight: 'bold' }}>{property.label}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                {property.value}
                            </Grid>
                        </Grid>
                    </div>
                ))}
            </Paper>
        )
    } else {
        ticketDetails = (
            <Paper sx={{ padding: 2 }} >
                <Grid container item className='w3-padding' justifyContent='center'>
                    <h5 className='w3-text-grey'>
                        No Data Found
                    </h5>
                </Grid>
            </Paper>
        )    
    }
    
    return (
        <Grid 
            container 
            sx={{
                padding: {
                xs: '12px 8px', 
                sm: '12px 8px', 
                md: '12px 24px' 
                }
            }}
        >
            <Grid container item xs={12}>
                <Grid item xs={5} justifyContent='flex-start'>
                    <IconButton
                         onClick={() => {
                            if ( digiTicketsQueryParams ) {
                                navigate(`/client/${client_id}/digitalisation/${facility_id}/tickets?${digiTicketsQueryParams?.toString()}`)
                            }else if ( ticketsQueryParams ) {
                                navigate(`/tickets?${ticketsQueryParams?.toString()}`)
                            }else if ( clientTicketsQueryParams ) {
                                navigate(`/client/${client_id}/client-tickets?${clientTicketsQueryParams?.toString()}`)
                            }else {
                                navigate(`/tickets`)
                            }
                        }}
                        color="inherit">
                        <ArrowBackIosIcon fontSize='small'/>
                    </IconButton>
                </Grid>
                <Grid item xs={7} justifyContent='flex-start'>
                    <h5 style={{ fontWeight: 'bold' }}>TICKET DETAILS</h5>
                </Grid>
            </Grid>
            <Grid item xs={12}>
               {ticketDetails}
            </Grid>
            {isGreenUser(uniqueId) && (<Grid item xs={12} mt={2} display='flex' justifyContent='end'>
                <Button 
                    style={{backgroundColor: '#008080', color: 'white'}}
                    variant="contained" 
                    color="primary" 
                    onClick={() => {
                        const payload = { 
                            status: selectedStatus,
                            comments: comments,
                            assignee: selectedAssignee
                        };
                        dispatch(updateTicket(ticket_id, payload)).then((res) => {
                            if (res?.data?.success) {
                            fetchData();
                            }
                        });
                    }}
                >
                    UPDATE
                </Button>
            </Grid>)}
        </Grid>
    )
}